import { render, staticRenderFns } from "./histogramEcharts.vue?vue&type=template&id=fcd51748&scoped=true&"
import script from "./histogramEcharts.vue?vue&type=script&lang=js&"
export * from "./histogramEcharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd51748",
  null
  
)

export default component.exports